import { Text } from '@procurify/ui'

import { useFormatStaticAsset } from '@webapp/core/hooks/useFormatStaticAsset'
import { VendorLogoBadgeLayoutStyled } from './styles/VendorLogoBadgeLayoutStyled'
import { VendorLogoBadgeMarkStyled } from './styles/VendorLogoBadgeMarkStyled'
import { type ConversationVendor } from '../../value-objects/ConversationTurnItem'

export const VendorLogoBadgeMarkHeights = {
  DEFAULT: 20,
  COMPACT: 16,
} as const

export type VendorLogoBadgeMarkHeight =
  (typeof VendorLogoBadgeMarkHeights)[keyof typeof VendorLogoBadgeMarkHeights]

export interface IVendorLogoBadgeProps {
  vendor: ConversationVendor
  markHeight?: VendorLogoBadgeMarkHeight
  outlined?: boolean
}

export const VendorLogoBadge = ({
  vendor,
  markHeight = VendorLogoBadgeMarkHeights.DEFAULT,
  outlined = true,
}: IVendorLogoBadgeProps) => {
  const formatStaticAsset = useFormatStaticAsset()

  return (
    <VendorLogoBadgeLayoutStyled $outlined={outlined}>
      {vendor.logoUrl ? (
        <VendorLogoBadgeMarkStyled
          src={formatStaticAsset(vendor.logoUrl)}
          alt={vendor.name}
          $height={markHeight}
        />
      ) : (
        <Text inline bold>
          {vendor.name}
        </Text>
      )}
    </VendorLogoBadgeLayoutStyled>
  )
}
